import { Flex, font, preventOneWordInLastLine, themedColor } from '@lemonade-hq/cdk';
import { Link, MEDIA_QUERIES } from '@lemonade-hq/nuis';
import { useI18nContext } from '@lemonade-hq/nuiza';
import type React from 'react';
import styled from 'styled-components';
import { LockSvg } from './LockSvg';

const Content = styled(Flex)`
  align-items: center;
  flex-direction: column;
  flex: 1;
  padding: 100px 20px 20px;

  ${MEDIA_QUERIES.mobile`
    padding: 40px 20px 20px;
  `};
`;

const ErrorHeader = styled.h1`
  ${font('alt', { fontSize: '3.6rem', lineHeight: 1.3 })};
  color: ${themedColor('night')};
  text-align: center;
  max-width: 720px;
  margin-bottom: 12px;
  margin-top: 24px;

  ${MEDIA_QUERIES.mobile`
    margin-bottom: 30px;   
  `}
`;

const ErrorSubtitle = styled.p`
  margin-bottom: 67px;
  max-width: 515px;
  text-align: center;
  ${font('main', { fontSize: '1.6rem', lineHeight: 1.3 })};

  ${MEDIA_QUERIES.mobile`
  margin-bottom: 50px;
    max-width: 300px;
  `};
`;

const InlineLink = styled.a`
  ${font('main', { fontSize: '1.6rem', lineHeight: 1.3 })};
`;

interface UnauthorizedProps {
  readonly backHomeUrl: string;
  readonly logoutUrl: string;
}

export const Unauthorized: React.FC<UnauthorizedProps> = ({ backHomeUrl, logoutUrl }) => {
  const { s } = useI18nContext();

  return (
    <Content alignItems="center" flex={1} flexDirection="column">
      <LockSvg />
      <ErrorHeader
        dangerouslySetInnerHTML={{
          __html: preventOneWordInLastLine(s('web.home_check.error.unauthorized.title')),
        }}
      />

      <ErrorSubtitle
        dangerouslySetInnerHTML={{
          __html: preventOneWordInLastLine(s('web.home_check.error.unauthorized.subtitle')),
        }}
      />

      <Flex alignItems="center" flexDirection="column" gap="16px">
        <Link flavor="primary" href={logoutUrl} minWidth={190}>
          {s('web.home_check.error.unauthorized.action')}
        </Link>
        <InlineLink href={backHomeUrl}>{s('web.home_check.error.unauthorized.secondaryAction')}</InlineLink>
      </Flex>
    </Content>
  );
};
